var render = function render(){var _vm=this,_c=_vm._self._c;return (this.$store.state.user)?_c('div',{staticClass:"wallet-name"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(this.$store.state.user.name))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }